import { immerable } from "immer";

export class CompetitorCategory {
    [immerable] = true;

    public readonly id: number;
    public readonly name: string;
    private _isSelected: boolean;

    constructor(
        id: number,
        name: string,
        isSelected: boolean
    ) {
        this.id = id;
        this.name = name;
        this._isSelected = isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}
